import { Difficulty } from "@ravalmatic/euchre-engine";
import { Language, PersistentDataManager } from "./PersistentDataManager";

export class Preferences {
    public static get difficulty(): Difficulty { return PersistentDataManager.gameData.difficulty; }
    public static get musicMuted(): boolean { return PersistentDataManager.gameData.musicMuted; }
    public static get sfxMuted(): boolean { return PersistentDataManager.gameData.sfxMuted; }
    public static get language(): Language { return PersistentDataManager.gameData.language; }
    public static get notice(): string { return PersistentDataManager.notice; }
    public static set notice(value: string) { PersistentDataManager.notice = value; }

    public static load(): void {
        PersistentDataManager.readGameData();
    }

    public static setDifficulty(difficulty: Difficulty): void {
        PersistentDataManager.updateGameData("difficulty", difficulty);
    }

    public static setMusicMuted(muted: boolean): void {
        PersistentDataManager.updateGameData("musicMuted", muted);
    }

    public static setSfxMuted(muted: boolean): void {
        PersistentDataManager.updateGameData("sfxMuted", muted);
    }

    public static setLanguage(language: Language): void {
        PersistentDataManager.updateGameData("language", language);
    }
}
